import { microApi } from 'app/services/api';
import { ListResponse } from 'app/types';
import qs from 'qs';
import pick from 'lodash/pick';

// const END_POINTS = 'admin/inspections/inspectors';
const END_POINTS = 'factories';
export const factoryApi = microApi.injectEndpoints({
  endpoints: (build) => ({
    getFactories: build.query<
      {
        data: Array<any>;
        pagination: {
          page: number;
          pageSize: number;
          pages: number;
          total: number;
        };
      },
      {
        current: number;
        pageSize: number;
        keywords?: string;
        categories?: Array<string | number>;
        searchBy: string;
      }
    >({
      query: (params) => {
        const extra: any = {};
        if (params.categories && params.categories.length) {
          extra['categoryIds'] = params.categories.map((id: any) => id);
        }
        const queryString = qs.stringify(
          {
            pageNo: params.current,
            pageSize: params.pageSize,
            ...pick(params, ['keywords', 'searchBy'])
          },
          {
            encodeValuesOnly: false,
            indices: false
          }
        );
        return {
          url: `${END_POINTS}${queryString ? '?' + queryString : ''}`,
          method: 'GET'
        };
      },
      transformResponse: (baseQueryReturnValue: ListResponse<any>) => {
        return {
          pagination: baseQueryReturnValue.data.pagination,
          data: baseQueryReturnValue.data.list
        };
      }
    }),
    getSuppliers: build.query<
      {
        data: Array<any>;
        pagination: {
          page: number;
          pageSize: number;
          pages: number;
          total: number;
        };
      },
      {
        current: number;
        pageSize: number;
        keywords?: string;
        categories?: Array<string | number>;
        searchBy: string;
      }
    >({
      query: (params) => {
        const extra: any = {};
        if (params.categories && params.categories.length) {
          extra['categoryIds'] = params.categories.map((id: any) => id);
        }
        const queryString = qs.stringify(
          {
            pageNo: params.current,
            pageSize: params.pageSize,
            ...pick(params, ['keywords', 'searchBy'])
          },
          {
            encodeValuesOnly: false,
            indices: false
          }
        );
        return {
          url: `suppliers${queryString ? '?' + queryString : ''}`,
          method: 'GET'
        };
      },
      transformResponse: (baseQueryReturnValue: ListResponse<any>) => {
        return {
          pagination: baseQueryReturnValue.data.pagination,
          data: baseQueryReturnValue.data.list
        };
      }
    })
  })
});

export const {
  useLazyGetFactoriesQuery,
  useGetFactoriesQuery,
  useLazyGetSuppliersQuery,
}: typeof factoryApi = factoryApi;
